<template>
    <div id="User">
        <v-card class="card-container elevation-12">
            <v-card-title primary-title>
                <h1 style="color:#1976D2;">{{userData.data.fullName}}</h1>
            </v-card-title>
            <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs6>
                        <h3>{{$t('Основная информация')}}</h3>
                        <v-flex xs12 sm12 md12 lg6>
                            <v-card>
                                <v-card-title>
                                    <h4>{{userData.systemRole[0].data.name}}</h4>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-list dense>
                                    <v-list-tile>
                                        <v-list-tile-content>{{$t('ИИН')}}:</v-list-tile-content>
                                        <v-list-tile-content class="align-end">{{userData.data.iin}}</v-list-tile-content>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-content>E-mail:</v-list-tile-content>
                                        <v-list-tile-content
                                            class="align-end"
                                        >{{userData.data.email}}</v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-card>
                        </v-flex>
                    </v-flex>
                    <v-flex xs6 v-if="showAccountsData">
                        <h3>{{$t('Доступные лицевые счета')}}</h3>
                        <v-data-iterator
                            :items="userAccounts"
                            :item-key="account_id"
                            hide-actions
                            content-tag="v-layout"
                            row
                            wrap
                        >
                            <template v-slot:item="props">
                                <v-flex xs12 sm12 md12 lg6>
                                    <v-card>
                                        <v-card-title>
                                            <h4>{{ props.item.account_id }}</h4>
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-list dense>
                                            <v-list-tile>
                                                <v-list-tile-content>{{$t('РОЭС')}}:</v-list-tile-content>
                                                <v-list-tile-content
                                                    class="align-end"
                                                >{{ props.item.roes_div_name }}</v-list-tile-content>
                                            </v-list-tile>
                                            <v-list-tile>
                                                <v-list-tile-content>РЭС:</v-list-tile-content>
                                                <v-list-tile-content
                                                    class="align-end"
                                                >{{ props.item.res_div_name }}</v-list-tile-content>
                                            </v-list-tile>
                                            <!-- <v-list-tile>
                        <v-list-tile-content>{{$t('Кол-во показаний')}}:</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ props.item.indications_count }}</v-list-tile-content>
                                            </v-list-tile>-->
                                        </v-list>
                                    </v-card>
                                </v-flex>
                            </template>
                        </v-data-iterator>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
export default {
    name: 'User',
    components: {},
    data: () => ({}),
    computed: {
        ...mapState('user', ['userData']),
        ...mapGetters('user', ['userAccounts']),
        showAccountsData() {
            return this.userAccounts.length > 0;
        }
    },
    methods: {},
    mounted() {}
};
</script>
